import { GetTimelineConversationParams } from '../stores/api/stayTimelineArriere'

interface TimelineConversationKeyParams {
  bookingId?: string
  args: Omit<GetTimelineConversationParams, 'bookingId'>
}

export const stayTimelineQueryKeys = {
  base() {
    return ['stay-timeline']
  },
  stayFacts(bookingId?: string) {
    return [...this.base(), 'stay-facts', bookingId]
  },
  bookingConversations(bookingId?: string) {
    return [...this.base(), 'timeline-conversation', bookingId]
  },
  timelineConversation({ bookingId, args }: TimelineConversationKeyParams) {
    return [...this.bookingConversations(bookingId), args]
  },
}
